'use strict';

angular.module('web2print.recipients')
  .factory('odrFactory', function (Common, addressCalculationFactory) {
    function isFetchingGrossCount () {
      return addressCalculationFactory.getUpdateSyncParams().isFetchingGrossCount;
    }

    function isFetchingRefinedCount () {
      return addressCalculationFactory.getUpdateSyncParams().isFetchingRefinedCount;
    }

    function getTargetType () {
      return Common.get('recipients.targetType');
    }

    function defaultFilters () {
      return {
        INDIVIDUALS: {
          formOfHousing: 'HOUSEHOLD'
        },
        COMPANIES: {
          formOfHousing: 'COMPANY'
        }
      };
    }

    return {
      isFetchingGrossCount,
      isFetchingRefinedCount,
      getTargetType,
      defaultFilters
    };
  });
